export const favoriteRegist = () => {
  // IDが "favorite-button_" で始まるすべてのボタン要素を取得
  const buttons = document.querySelectorAll('[id^="favorite-button_"]');

  // 該当要素が1つもなければ何もせず終了
  if (buttons.length === 0) return;

  // 各ボタンにクリックイベントを設定
  buttons.forEach((button) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault(); // デフォルトのリンク動作を無効化

      // ボタンのIDから商品IDを抽出（例: "favorite-button_123" → "123"）
      const idParts = button.id.split('_');
      const id = idParts[idParts.length - 1];

      // 送信データをURLエンコード形式で準備
      const postData = new URLSearchParams({ goods_id: id });

      // リクエスト先のパス
      const path = '/action/favorite.php';

      try {
        // fetch を使って POST リクエストを送信
        const response = await fetch(path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: postData.toString(), // 文字列に変換して送信
        });

        // レスポンスを JSON としてパース
        const data = await response.json();

        // 未認証の場合はリダイレクト
        if (data.status === 'unauthenticated') {
          window.location.href = data.redirect;
          return;
        }

        // 成功した場合はボタンのスタイルを切り替え
        if (data.status === 'success') {
          const text = button.querySelector('.favorite-text');
          if (data.action === 'added') {
            if (text) {
              text.textContent = 'お気に入りに追加済み';
            }
            button.classList.add('favorited');
          }
          if (data.action === 'removed') {
            if (text) {
              text.textContent = 'お気に入りに追加する';
            }
            button.classList.remove('favorited');
          }
          if (data.action === 'unchanged') {
            if (text) {
              text.textContent = 'お気に入り数が上限です';
            }
            button.classList.add('inactive');
          }
        }
      } catch (error) {
        // 通信エラーやJSON解析エラーが発生した場合のログ
        console.error('通信に失敗しました:', error);
      }
    });
  });
};
